let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("c764A")).then(() => parcelRequire('ePCig'));